import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
} from '@angular/core';
import { OverlayRef, TelXLOverlayComponent } from '@dxp/components';
import { TelXLButtonComponent } from '@dxp/elements';

@Component({
    selector: 'end-customer-swap-customer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TelXLOverlayComponent, TelXLButtonComponent],
    templateUrl: './swap-customer.component.html',
    styleUrl: './swap-customer.component.scss',
})
export class SwapCustomerModalComponent {
    #overlayRef = inject(OverlayRef<boolean>);

    swapTo = input.required<string>();
    swapToName = computed<string>(() => {
        return this.swapTo() && this.swapTo().length > 0
            ? this.swapTo()
            : 'Unknown Customer';
    });

    close(result: boolean) {
        this.#overlayRef.close(result);
    }
}
